import { createFileRoute } from '@tanstack/react-router';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';
import BundleDetail from '../../components/webdesigned/BundleDetail';

export const Route = createFileRoute('/webdesigned/forfaits_/$id')({
  component: () => (
    <WebDesignedPortal>
      <BundleDetail />
    </WebDesignedPortal>
  ),
});
